import React, {useCallback, useEffect, useRef} from "react";
import {
    Chip,
    ButtonGroup,
    Button,
    Select,
    SelectItem,
    Divider,
    Card,
    CardHeader,
    CardBody,
    CheckboxGroup,
    Checkbox,
    Autocomplete,
    AutocompleteItem, Tooltip
} from "@nextui-org/react";
import {FaEdit, FaTrash, FaEye, FaPlusCircle, FaPlus, FaMinus, FaSave, FaList, FaUser} from 'react-icons/fa'
import {CreateStock, getMachines, getStockbyMachine, getUnassignedStock, SaveStock} from "../API";
import {useNavigate} from "react-router-dom";
import {toast, Toaster} from "sonner";
import {StockStatus} from './Globals'

// tailwindcss: grid-cols-1 grid-cols-2 grid-cols-3
const statusColorMap = StockStatus;

export default function Stock() {
    const [machines, setMachines] = React.useState([]);
    const [idmachine, setIdmachine] = React.useState([]);
    const [positions, setPositions] = React.useState([]);
    const [stock, setStock] = React.useState([]);
    const [stockItem, setStockItem] = React.useState([]);
    const [machineCols, setMachineCols] = React.useState(1);
    const [inStock, setInStock] = React.useState(0);
    const [inUse, setInUse] = React.useState(0);
    const navigate = useNavigate();
    const gridRef = useRef(null);
    const [isLoading, setisLoading] = React.useState(false);

    useEffect(() => {
        Starting();
    }, []);

    const renderCallback = useCallback((data) => {
        if (data) {
            if (!data.new && data.status !== "NA") {
                return (
                    <div className="flex items-center gap-2">
                        <Button isIconOnly color="transparent" onPress={() => GoToDetails(data, [])}><FaEdit/></Button>
                        <Chip
                            color={statusColorMap[data.status][0]}>C {data.iddoor} -
                            S {data.idstock} : {data.name !== null ? data.name : statusColorMap[data.status][1]}</Chip>
                    </div>

                )
            } else {
                return (
                    <div className="flex items-center gap-2">
                        <Button isIconOnly color="transparent" onPress={() => Assing(data)}>{data.status === "PE" ?
                            <FaMinus/> : <FaPlus/>}</Button>
                        <Chip
                            color={statusColorMap[data.status][0]}>C {data.iddoor} : {data.name !== null ? data.name : statusColorMap[data.status][1]}</Chip>
                    </div>
                )
            }

        }

    })

    useEffect(() => {
        const used = positions.filter(p => p.idproduct === stockItem.idproduct && p.new).length;
        setInUse(used);
    }, [positions, stockItem]);

    async function Assing(data) {

        if (data.status === "PE") {
            const updatedItems = positions.map(item =>
                item.idposition === data.idposition ? {
                    ...item,
                    status: "NA",
                    name: null,
                    idstock: null,
                    code_stock: null,
                    new: true,
                    idproduct: null
                } : item
            );
            setPositions(updatedItems)

            setStockItem(prev => {
                const updatedStock = [...prev.stock];
                const exist = stockItem.stock.findIndex(s => s.idposition_assigned === data.idposition);
                updatedStock[exist] = {...updatedStock[exist], idposition_assigned: null};
                return {
                    ...prev,
                    stock: updatedStock ? updatedStock : prev.stock
                }

            });
            return;
        }

        if (stockItem.idproduct) {
            let idstock = 0;
            let idproduct = 0;
            let code_stock = '';
            const exist = stockItem.stock.findIndex(s => s.idposition_assigned === null);
            if (exist !== -1) {
                setStockItem(prev => {
                    const updatedStock = [...prev.stock];
                    updatedStock[exist] = {...updatedStock[exist], idposition_assigned: data.idposition};

                    idstock = updatedStock[exist].idstock;
                    idproduct = updatedStock[exist].idproduct;
                    code_stock = updatedStock[exist].code_stock;
                    return {
                        ...prev,
                        stock: updatedStock ? updatedStock : prev.stock
                    }

                });

                const updatedItems = positions.map(item =>
                    item.idposition === data.idposition ? {
                        ...item,
                        status: "PE",
                        name: stockItem.name,
                        idstock: idstock,
                        code_stock: code_stock,
                        new: true,
                        idproduct: idproduct
                    } : item
                );
                setPositions(updatedItems)


                const updateListStock = stock.map(item => item.idproduct === stockItem.idproduct ? {
                    ...item,
                    stock: stockItem.stock
                } : item);
                setStock(updateListStock);


            } else
                toast.warning("Este producto se encuentra totalmente asignado.")

        } else
            toast.error("Seleccionar un producto! 😥")


    }

    async function Starting() {
        const m = await getMachines();
        const s = await getUnassignedStock({'status': 'RP', 'iduser': 0});
        setStock(s);
        setMachines(m);
    }

    async function OnSelectMachine(e) {
        const s = await getStockbyMachine(e.target.value);
        setIdmachine(e.target.value);
        const data = machines.find(m => m.idmachine === e.target.value);
        if (data) {
            const col = machines.find(m => m.idmachine === e.target.value).columns
            if (gridRef.current.classList.contains(`grid-cols-${machineCols}`))
                gridRef.current.classList.remove(`grid-cols-${machineCols}`);

            gridRef.current.classList.add(`grid-cols-${col}`);

            setPositions(s);
            setMachineCols(col);
        } else
            setPositions([])
    }

    function GoToDetails(data, ma) {
        navigate("/dashboard/stock-edition", {state: {data: data}});
    }

    function GoToAssignation(e) {
        navigate("/dashboard/stock-assign");
    }

    function GoToList(e) {
        navigate("/dashboard/stock-list");
    }

    function GoToCreate(e) {
        navigate("/dashboard/stock-details");
    }

    function OnSelectStock(index) {
        if (index === null) {
            setStockItem([]);
            return;
        }
        const s = stock[index];
        setStockItem(s);
        setInStock(s.stock.length);
        setInUse(s.stock.filter(item => item.idposition_assigned !== null).length);
    }

    async function OnSave(e) {
        e.preventDefault();
        setisLoading(true);
        const modified = positions.filter(item => item.new !== undefined && item.idstock !== null);
        const item = {
            "idmachine": idmachine,
            "positions": modified
        }

        const data = await SaveStock(item);
        if (data) {
            setPositions(data);
            toast.success("Stock actualizado correctamente. ✅")
        } else
            toast.error("Ha ocurrido un error. 😥")

        setisLoading(false);
    }

    return (
        <>

            <Toaster richColors/>
            <ButtonGroup className="p-3">
                <Button onPress={GoToCreate}><FaPlusCircle
                    className="text-success"/> Stock</Button>
                <Button onPress={GoToAssignation}><FaUser
                    className="text-secondary"/> Asignacion</Button>
                <Button onPress={GoToList}><FaList
                    className="text-warning"/> Lista del Stock</Button>
            </ButtonGroup>
            <Divider orientation="horizontal"/>
            <Select
                //className="p-5"
                labelPlacement="outside"
                label="Maquina"
                //selectedKeys={['TM1']}
                name="parent"
                onChange={OnSelectMachine}
                items={machines}>
                {
                    (items) => (
                        <SelectItem key={items.idmachine} value={items.idmachine}>{items.idmachine}</SelectItem>)
                }
            </Select>
            <Divider orientation="horizontal"/>
            <form className="container" onSubmit={OnSave}>
                <h2 className="text-xl text-warning">Celdas en maquina</h2>
                <div className="flex w-full flex-shrink">
                    <div className="flex w-full flex-wrap gap-4 p-5">
                        <Chip color="primary">Asignado</Chip>
                        <Chip color="success">Sin asignacion</Chip>
                        <Chip color="warning">Pendiente</Chip>
                    </div>
                    <Tooltip content="Guardar">
                        <Button color="success" variant="ghost" isLoading={isLoading} isIconOnly
                                isDisabled={inUse === 0} type="submit"><FaSave/></Button>
                    </Tooltip>
                </div>
                <Divider orientation="horizontal"/>
                <div className="flex w-full flex-col p-5">
                    <Autocomplete
                        label="Seleccionar producto del stock"
                        className="max-w-xs"
                        onSelectionChange={OnSelectStock}
                        isClearable={false}
                    >
                        {
                            stock.map((item, index) => (
                                <AutocompleteItem key={index} value={item.idproduct}
                                                  textValue={`${item.name} (${item.stock.length})`}>
                                    {item.name} ({item.stock.length})
                                </AutocompleteItem>
                            ))
                        }
                    </Autocomplete>

                    <p className="mt-1 text-small text-default-500 pb-3">Cantidad
                        disponible: {inStock}</p>
                    <p className="text-small text-default-500">Cantidad asignada: {inUse}</p>

                </div>
                <Divider orientation="horizontal"/>
                <div className={`pt-4 grid grid-cols-${machineCols} gap-4`} ref={gridRef}>
                    {
                        positions.length > 0 ? (
                            positions.map((item, index) => (

                                item.parent === 0 ? (
                                    <Card key={index}>
                                        <CardHeader className="text-2xl">{item.code}</CardHeader>
                                        <CardBody>
                                            <CheckboxGroup>
                                                {
                                                    renderCallback(item)
                                                }
                                                {
                                                    positions.map((child, index) => (
                                                        child.parent !== 0 && child.parent === item.idposition ? (
                                                            <div key={child.idposition}>
                                                                {
                                                                    renderCallback(child)
                                                                }
                                                            </div>
                                                        ) : null
                                                    ))
                                                }
                                            </CheckboxGroup>
                                        </CardBody>
                                    </Card>
                                ) : null

                            ))
                        ) : null
                    }
                </div>
            </form>

        </>

    );
}
